// src/i18n.js

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      // Dashboard Metrics
      dashboardMetrics: {
        totalCustomers: "Customers",
        qrAccumulated: "QR Accumulated",
        qrRedeemed: "QR Redeemed",
        giftsRedeemed: "Gifts Redeemed",
      },

      // Menu Items
      menu: {
        viewCustomers: "View Customers",
        redemptionList: "Redemption List",
        giftsAllotments: "Gifts Allotments",
      },

      // Salesmen
      salesmen: {
        assignCustomers: "View Customers",
      },

      // Consumer
      consumer: {
        redemptionList: "Redemption List",
      },

      // Gifts
      gifts: {
        allocateGifts: "Gift Distribution",
      },

      // Dashboard Labels
      dashboard: {
        specialOffers: "Special Offers",
        customers: "Customers",
        qrAccumulated: "QR Accumulated",
        qrRedeemed: "QR Redeemed",
        giftsRedeemed: "Gifts Redeemed",
        customerDashboard: "Customer Dashboard",
        welcome: "Welcome",
        error: "Error",
        failedToLoad: "Failed to load dashboard data",
        qrCodesAccumulated: "QR Codes Accumulated",
        qrCodesRedeemed: "QR Codes Redeemed",
        accumulatedQRCodes: "Accumulated QR Codes",
        redeemedQRCodes: "Redeemed QR Codes",
        giftsRedeemedTitle: "Gifts Redeemed",
        scheme: "Scheme",
        amount: "Amount",
        date: "Date",
        giftName: "Gift Name",
        noDataAvailable: "No Data Available",
        noActivityData: "No activity data available yet. Start by scanning QR codes and redeeming gifts.",
        loadingDashboard: "Loading dashboard data...",
      },

      // Tables
      tables: {
        customers: "Customers",
        accumulatedQR: "Accumulated QR Codes",
        redeemedQR: "Redeemed QR Codes",
        giftsRedeemed: "Gifts Redeemed",
      },

      // Columns
      columns: {
        name: "Name",
        mobile: "Mobile",
        city: "City",
        state: "State",
        createdAt: "Created At",
        qrId: "QR ID",
        customerName: "Customer Name",
        customerMobile: "Customer Mobile",
        giftName: "Gift Name",
        qrScheme: "QR Scheme",
      },

      // Pagination
      pagination: {
        pageOf: "Page",
        of: "of",
        prev: "Prev",
        next: "Next",
      },

      // Messages
      messages: {
        noMatchFound: "No match found",
      },

      // Buttons
      buttons: {
        english: "English",
        kannada: "ಕನ್ನಡ",
      },
    },
  },

  kn: {
    translation: {
      // Dashboard Metrics
      dashboardMetrics: {
        totalCustomers: "ಗ್ರಾಹಕರು",
        qrAccumulated: "QR ಸಂಗ್ರಹಿಸಲಾಗಿದೆ",
        qrRedeemed: "QR ಮರುಪಡೆಯಲಾಗಿದೆ",
        giftsRedeemed: "ಉಪಹಾರಗಳನ್ನು ಮರುಪಡೆಯಲಾಗಿದೆ",
      },

      // Menu Items
      menu: {
        viewCustomers: "ಗ್ರಾಹಕರನ್ನು ನೋಡಿ",
        redemptionList: "ರಿಡೆಂಪ್ಟನ್ ಪಟ್ಟಿ",
        giftsAllotments: "ಉಪಹಾರಗಳ ಹಂಚಣೆ",
      },

      // Salesmen
      salesmen: {
        assignCustomers: "ಗ್ರಾಹಕರನ್ನು ನೋಡಿ",
      },

      // Consumer
      consumer: {
        redemptionList: "ರಿಡೆಂಪ್ಟನ್ ಪಟ್ಟಿ",
      },

      // Gifts
      gifts: {
        allocateGifts: "ಉಪಹಾರಗಳ ಹಂಚಣೆ",
      },

      // Dashboard Labels
      dashboard: {
        specialOffers: "ವಿಶೇಷ ಆಫರ್ಗಳು",
        customers: "ಗ್ರಾಹಕರು",
        qrAccumulated: "QR ಸಂಗ್ರಹಿಸಲಾಗಿದೆ",
        qrRedeemed: "QR ಮರುಪಡೆಯಲಾಗಿದೆ",
        giftsRedeemed: "ಉಪಹಾರಗಳನ್ನು ಮರುಪಡೆಯಲಾಗಿದೆ",
        customerDashboard: "ಗ್ರಾಹಕ ಡ್ಯಾಶ್ಬೋರ್ಡ್",
        welcome: "ಸ್ವಾಗತ",
        error: "ದೋಷ",
        failedToLoad: "ಡ್ಯಾಶ್ಬೋರ್ಡ್ ಡೇಟಾ ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ",
        qrCodesAccumulated: "QR ಕೋಡ್ಗಳು ಸಂಗ್ರಹಿಸಲಾಗಿದೆ",
        qrCodesRedeemed: "QR ಕೋಡ್ಗಳು ಮರುಪಡೆಯಲಾಗಿದೆ",
        accumulatedQRCodes: "ಸಂಗ್ರಹಿಸಿದ QR ಕೋಡ್ಗಳು",
        redeemedQRCodes: "ಮರುಪಡೆದ QR ಕೋಡ್ಗಳು",
        giftsRedeemedTitle: "ಮರುಪಡೆದ ಉಪಹಾರಗಳು",
        scheme: "ಯೋಜನೆ",
        amount: "ಮೊತ್ತ",
        date: "ದಿನಾಂಕ",
        giftName: "ಉಪಹಾರದ ಹೆಸರು",
        noDataAvailable: "ಡೇಟಾ ಲಭ್ಯವಿಲ್ಲ",
        noActivityData: "ಇನ್ನೂ ಚಟುವಟಿಕೆ ಡೇಟಾ ಲಭ್ಯವಿಲ್ಲ. QR ಕೋಡ್ಗಳನ್ನು ಸ್ಕ್ಯಾನ್ ಮಾಡುವ ಮೂಲಕ ಪ್ರಾರಂಭಿಸಿ ಮತ್ತು ಉಪಹಾರಗಳನ್ನು ಮರುಪಡೆಯಿರಿ.",
        loadingDashboard: "ಡ್ಯಾಶ್ಬೋರ್ಡ್ ಡೇಟಾ ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
      },

      // Tables
      tables: {
        customers: "ಗ್ರಾಹಕರು",
        accumulatedQR: "ಸಂಗ್ರಹಿತ ಕ್ಯೂಆರ್ ಕೋಡ್‌ಗಳು",
        redeemedQR: "ರಿಡೀಮ್ ಮಾಡಲಾದ ಕ್ಯೂಆರ್ ಕೋಡ್‌ಗಳು",
        giftsRedeemed: "ರಿಡೀಮ್ ಮಾಡಲಾದ ಉಪಹಾರಗಳು",
      },

      // Columns
      columns: {
        name: "ಹೆಸರು",
        mobile: "ಮೊಬೈಲ್",
        city: "ನಗರ",
        state: "ರಾಜ್ಯ",
        createdAt: "ರಚಿಸಿದ",
        qrId: "ಕ್ಯೂಆರ್ ಐಡಿ",
        customerName: "ಗ್ರಾಹಕ ಹೆಸರು",
        customerMobile: "ಗ್ರಾಹಕ ಮೊಬೈಲ್",
        giftName: "ಉಪಹಾರ ಹೆಸರು",
        qrScheme: "ಕ್ಯೂಆರ್ ಸ್ಕೀಮ್",
      },

      // Pagination
      pagination: {
        pageOf: "ಪುಟ",
        of: "ರ",
        prev: "ಹಿಂದೆ",
        next: "ಮುಂದೆ",
      },

      // Messages
      messages: {
        noMatchFound: "ಹೊಂದಿಕೆ ಕಂಡುಬಂದಿಲ್ಲ",
      },

      // Buttons
      buttons: {
        english: "English",
        kannada: "ಕನ್ನಡ",
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: "en", // Set default language to English
    fallbackLng: "en",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;